import React, {Component} from 'react';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';
import './expo-list.css';

/** @class ArchivedExpo
  * Displays information and links for an
  * archived expo.
  */
export default class ArchivedExpo extends Component {
  /** @function constructor
    * Builds a new instance of an archived
    * virtual expo
    * @param {String} expoID of the expo
    */
  constructor(props) {
    super(props);
    this.firebaseRef = firebase.database().ref(`/expos/${props.expoID}/metadata`);
    this.state = {}
  }
  /** @method componentWillMount
    * Connects the component to the Firebase database
    */
  componentWillMount() {
    this.firebaseRef.on('value', (snapshot) => {
      this.setState(snapshot.val());
    });
  }
  /** @method componentWillUnmount
    * Frees the Firebase database listener
    */
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @method render
    * Renders the archived expo
    */
  render() {
    return(
      <li className="archived-expo">
        <span>
          <FontAwesome name="file-archive-o"/>
          {this.props.year}
        </span>
        <a href={`https://${this.state.host}/archives/${this.props.year}`}>
          {`${this.state.host}/archives/${this.props.year}`}
          <FontAwesome name="external-link"/>
        </a>
        {new Date(this.state.opens).toLocaleString()} to
        {new Date(this.state.closes).toLocaleString()}
        <span>
          <FontAwesome name="bar-chart" onClick={()=>alert("reports coming soon...")}/>
        </span>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/series-list/archived-expo.js